import React from "react"

import AccountInfo from "./views/AccountInfo";
import Payments from "./views/Payments";
import PlanSuscription from "./views/PlanSuscription";
import ModulesUpgrades from "./views/ModulesUpgrades";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_active : "plan-upgrades"
            }
    }

    render() {
        return (
            <div className="layout">
                <div className={"account-data "  + (this.props.section_active !== "account-data" ? "hide" : "")}>
                    <AccountInfo
                    />
                </div>
                <div className={"plan-suscription "  + (this.props.section_active !== "plan-suscription" ? "hide" : "")}>
                    <PlanSuscription
                    />
                </div>
                <div className={"payments "  + (this.props.section_active !== "payments" ? "hide" : "")}>
                    <Payments
                    />
                </div>
                <div className={"modules-upgrades "  + (this.props.section_active !== "modules-upgrades" ? "hide" : "")}>
                    <ModulesUpgrades
                    />
                </div>
                
                
            </div>
        )
    }

}

export default Layout


// WEBPACK FOOTER //
// ./src/Setup/modules/account/Layout.js